import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { Button, TextInput, Text, LibColor } from '../../new-libby';
import { Icon } from '../../primitives/icon/icon';
import { iconsMap } from '../../icons';
import { Popover } from '../../primitives/popover/popover';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { ListDragHandle } from '../../primitives/sortable-list';
import { Toggle } from '../../primitives/toggle/toggle';
import { Column, Row } from '../../primitives';
// tslint:disable-next-line: cyclomatic-complexity
export var SortableInputListItem = function (props) {
    var _a, _b, _c, _d;
    var _e = React.useState(false), isPopoverOpen = _e[0], setPopoverOpen = _e[1];
    var classNames = namespacedClassnames(compKey, props.className, props.errorData.innerValuesError ? 'has-error-inside' : '', props.errorData.currentValueError ? 'current-value-error' : '', props.isSelected ? 'selected' : '', props.onAddNewLevel ? 'no-children-inside' : '', props.title ? 'has-title' : '');
    var propagationStopper = function (e) { return e.stopPropagation(); };
    var togglePopover = function () { return isPopoverOpen ? setPopoverOpen(false) : setPopoverOpen(true); };
    var openPopover = function (e) {
        if (e) {
            propagationStopper(e);
        }
        togglePopover();
    };
    var closePopover = function (e) {
        if (e) {
            propagationStopper(e);
        }
        togglePopover();
    };
    var onDeleteListItemViaPopover = function (e) {
        props.onDelete();
        togglePopover();
        e === null || e === void 0 ? void 0 : e.stopPropagation();
    };
    var renderPopoverBody = (React.createElement("div", { className: namespacedClassnames(compKey + "-popover-body") },
        React.createElement(Text, { type: 'hnm' }, (_a = props.deleteItemData) === null || _a === void 0 ? void 0 : _a.title),
        React.createElement(Text, { className: 'description', color: 't30' }, (_b = props.deleteItemData) === null || _b === void 0 ? void 0 : _b.description),
        React.createElement("div", { className: 'buttons-container' },
            React.createElement(Button, { className: compKey + "-cancel-item-btn", type: 'secondary', onClick: closePopover }, props.t('common.cancel')),
            React.createElement(Button, { className: compKey + "-confirm-remove-btn", intent: 'danger', onClick: onDeleteListItemViaPopover }, props.t('common.libby.delete-option')))));
    var dragHandle = React.createElement("div", { className: props.isDragReorderItemDisabled ? 'disabled' : '' },
        " ",
        React.createElement(ListDragHandle, null),
        " ");
    var arrowIcon = (React.createElement(Icon, { className: compKey + "-arrow", icon: iconsMap.smallArrow, color: props.isSelected ? LibColor.white : LibColor.blue100 }));
    var valueErrorInfo = React.createElement(Text, { type: 'ts', color: 't01', className: compKey + "-value-error-info-text" }, props.errorData.currentValueError);
    var onAddNewItem = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (e) {
                propagationStopper(e);
            }
            if (props.onAddNewLevel) {
                props.onAddNewLevel();
            }
            return [2 /*return*/];
        });
    }); };
    var addButton = (React.createElement(Tooltip, { body: props.addItemTextInfo || '', relativeToBody: true, forceHidden: !props.addItemTextInfo || !!props.isAddNewLevelDisabled },
        React.createElement(Button, { className: compKey + "-add-button", onClick: onAddNewItem, type: 'tertiary', disabled: props.isAddNewLevelDisabled },
            React.createElement(Icon, { icon: iconsMap.plus, color: props.isAddNewLevelDisabled ? LibColor.grey100 :
                    props.isSelected ? LibColor.white : undefined }))));
    var isRemoveTooltipHidden = !((_c = props.deleteItemData) === null || _c === void 0 ? void 0 : _c.tooltipInfo) || isPopoverOpen || !!props.removeDisabled || !!props.errorData.innerValuesError;
    var removeButton = (React.createElement("div", { className: compKey + "-remove-button-wrapper", onClick: propagationStopper },
        React.createElement(Button, { className: compKey + "-remove-button", onClick: props.deleteItemData ? openPopover : props.onDelete, disabled: props.removeDisabled ? "" + props.removeDisabled : '', type: 'tertiary' },
            React.createElement(Tooltip, { body: props.removeDisabled || ((_d = props.deleteItemData) === null || _d === void 0 ? void 0 : _d.tooltipInfo) || '', forceHidden: isRemoveTooltipHidden, relativeToBody: true },
                ";",
                React.createElement(Icon, { icon: iconsMap.remove, color: props.isSelected ? LibColor.white : props.removeDisabled ? LibColor.grey100 : LibColor.red140 })))));
    var removeItemButton = (React.createElement(Popover, { bringToFront: true, body: renderPopoverBody, isOpen: isPopoverOpen, onOuterAction: closePopover, className: namespacedClassnames(compKey + "-popover") }, removeButton));
    var toggleItemButton = function () {
        var _a = props.toggleData, onToggle = _a.onToggle, toggled = _a.toggled, disabled = _a.disabled;
        var onChange = function (_, e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            onToggle();
        };
        return React.createElement(Toggle, { value: toggled, onChange: onChange, disabled: disabled, size: 'xsmall', color: props.isSelected ? LibColor.blue80 : undefined });
    };
    var toggleOrRemoveButton = props.toggleData ? toggleItemButton() : removeItemButton;
    var textInput = (React.createElement("div", { onClick: propagationStopper },
        React.createElement(TextInput, { value: props.value, disabled: props.disabled, placeholder: props.placeholder || props.t('common.input.plaecholder'), onChange: props.onChange, autoFocus: props.isFocused, onFocus: props.onSelect })));
    var textInputWithError = (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { className: compKey + "-value-error", body: valueErrorInfo, forceHidden: !!props.errorData.innerValuesError, relativeToBody: true },
            React.createElement(Icon, { icon: iconsMap.alertRound })),
        textInput));
    var input = props.errorData.currentValueError ? textInputWithError : textInput;
    var inputContainer = React.createElement("div", { className: compKey + "-input-container" }, input);
    var levelActions = React.createElement("div", { className: compKey + "-level-actions" }, props.onAddNewLevel ? addButton : arrowIcon);
    var maybeTitle = props.title ? React.createElement(Text, { type: 'ht', color: 't40', className: compKey + "-title" }, props.title) : null;
    var listItem = (React.createElement("div", { onClick: props.onSelect },
        React.createElement(Column, { gap: '8', verticalAlignment: 'center', horizontalAlignment: 'start', className: classNames },
            maybeTitle,
            React.createElement(Row, { verticalAlignment: 'center', gap: '8' },
                dragHandle,
                inputContainer,
                toggleOrRemoveButton,
                levelActions))));
    var listItemWithErrorsInside = (React.createElement(Tooltip, { align: 'left', direction: 'right', relativeToBody: true, body: props.errorData.innerValuesError ? props.errorData.innerValuesError : '' }, listItem));
    return props.errorData.innerValuesError ? listItemWithErrorsInside : listItem;
};
//# sourceMappingURL=index.js.map